module.exports = __webpack_public_path__ + "img/icon-server-f460.04529b1c.svg";